import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { apps } from '../data/apps-privacy-policy';
import { Link } from 'react-router-dom';

const AppsPrivacyPolicyDetailPage = () => {
  const { t } = useTranslation();
  const { appId } = useParams();
  const app = apps.find((a) => a.id === appId);

  if (!app) {
    return (
      <>
        <div className="bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{t('apps_privacy_policy.app_not_found.title')}</h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              {t('apps_privacy_policy.app_not_found.description')}
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link to="/apps-privacybeleid" className="rounded-md bg-juniper-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-juniper-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-juniper-600">{t('apps_privacy_policy.app_not_found.button_text')}</Link>
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="mx-auto max-w-2xl">
          <p class="text-base font-semibold leading-7 text-juniper-600"><Link to="/apps-privacybeleid">{t('apps_privacy_policy.detail_page.go_back')}</Link></p>
          <h2 className="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{app.name}</h2>
          <div className="mt-10" dangerouslySetInnerHTML={{ __html: app.privacyPolicy }} />
        </div>
      </div>
    </>
  );
};

export default AppsPrivacyPolicyDetailPage; 